import { render, staticRenderFns } from "./leads.vue?vue&type=template&id=61245f66&"
import script from "./leads.vue?vue&type=script&lang=js&"
export * from "./leads.vue?vue&type=script&lang=js&"
import style0 from "./leads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports